var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #A7D379;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.8,217.06c-130.53,0-236.72,106.19-236.72,236.72,0,44.1,12.21,87.14,35.34,124.48l187.91,302.81c3.6,5.8,9.94,9.32,16.76,9.32h.15c6.88-.06,13.23-3.69,16.77-9.59l183.12-305.75c21.84-36.55,33.39-78.49,33.39-121.28,0-130.53-106.19-236.72-236.72-236.72ZM703.27,554.8l-166.48,277.97-170.84-275.3c-19.24-31.08-29.68-66.93-29.68-103.69,0-108.77,88.76-197.53,197.53-197.53s197.4,88.76,197.4,197.53c0,35.67-9.75,70.61-27.93,101.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.8,335.42c-65.26,0-118.36,53.09-118.36,118.36s52.23,118.36,118.36,118.36,118.36-54.23,118.36-118.36-53.1-118.36-118.36-118.36ZM533.8,532.95c-43.73,0-79.17-35.55-79.17-79.17s35.66-79.17,79.17-79.17,79.04,35.66,79.04,79.17-34.61,79.17-79.04,79.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6d67cd50d7d8f28d7ff08fb2f9e8a55d.svg";
export { ForwardRef as ReactComponent };